import {useState} from "react"

import {useAppContext} from "./useAppContext";
import {useQuery} from "@apollo/client";
import {contentService} from "../api/contentService";
import {ItemClassificationType} from "../definitions/enums";
import {Nullable, QuestionEdgeType} from "../definitions/types";
import {QuestionsModel} from "../models/view/questionsModel";
import {questionConnectionPageSize} from "../utils/constants";

const defaultConnection = {
    edges: [] as Nullable<QuestionEdgeType>[],
    pageInfo: {
        hasNextPage: false,
        hasPreviousPage: false,
        startCursor: undefined,
        endCursor: undefined
    }
};

export const useQuestionsQuery = () => {
    const {productId, primaryId, catalogId} = useAppContext();
    const [fetchNextPageLoading, setFetchNextPageLoading] = useState<boolean>(false);
    const [open, setOpen] = useState<boolean>(false);

    const {data, loading, fetchMore, error} = useQuery(contentService.questions.connection.query, {
        fetchPolicy: 'network-only',
        variables: {
            id: primaryId ?? productId,
            type: primaryId ? ItemClassificationType.Primary : ItemClassificationType.Standalone,
            productId: productId,
            last: questionConnectionPageSize
        }
    });

    const {
        questionEdges,
        pageInfo
    } = new QuestionsModel(data?.userContent?.primaryQuestions?.connection ?? data?.userContent?.questions?.connection ?? defaultConnection);

    return {
        open,
        setOpen,
        breakOutEarly: error || questionEdges.length === 0,
        questionEdges,
        pageInfo,
        fetchNextPage: async () => {
            if (!pageInfo.hasNextPage) return;
            setFetchNextPageLoading(true);
            fetchMore({variables: {before: pageInfo.endCursor}})
                .catch()
                .finally(() => setFetchNextPageLoading(false));
        },
        fetchNextPageLoading,
        loading,
        error: error?.message
    }
}